import React from "react";
import img from "./contactImg.svg";
import ContactForm from "../contact us/ContactForm";
import { useWebData } from "../../Context/webDataContext";

function ContactHomePage() {
  const { getContactPageData } = useWebData();
  const contactData = getContactPageData();
  console.log("contact", contactData)

  return (
    <section className="lg:mt-12 lg:py-16 " id="contact">
      {/* Title + Subtitle */}
      <div className="text-center md:mb-10 mb-4">
        <h2 className="md:text-4xl text-2xl font-extrabold text-[#08875D] leading-tight">
          {contactData.contactHeading || "How Can We Help You?"}
        </h2>
        <p className="text-gray-700 md:text-lg text-base max-w-2xl mx-auto md:mt-4 mt-2">
          {contactData.contactSubHeading ||
            "Got a question, feedback, or need assistance? Our team at Maideaze is here to support you every step of the way."}
        </p>
      </div>

      {/* Content Row */}
      <div className="flex flex-col md:flex-row items-center md:space-y-0 space-y-4 lg:gap-10 px-1">
        {/* Left: Illustration */}
        <div className="w-full md:w-1/2 lg:max-h-[28vw] flex justify-center">
        {contactData &&  <img
            src={contactData.contactImage}
            alt="Contact Illustration"
            className="transition-transform duration-300 hover:scale-105 drop-shadow-lg rounded-lg"
          />}
        </div>

        {/* Right: Contact Form */}
        <div className="w-full md:w-1/2 bg-white rounded-2xl p-2 backdrop-blur-md ">
          <h3 className="text-2xl font-semibold text-[#08875D] mb-4 text-center">
            Get In Touch
          </h3>
          <ContactForm />
        </div>
      </div>
    </section>
  );
}

export default ContactHomePage;
